export default {
  //關於我們
  about: {
    aboutUs: "關於我們",
    des1: " 薄盒Mints是北京擘盒科技有限公司旗下數字潮玩收藏平台，基於區塊鏈技術確權數字內容，提供可信存證技術、藏品數字憑證技術服務。通過生活中隨處可見的智能手機和電子屏，重新定義新的收藏方式。致力於持續提升數字藏品的消費和收藏互動體驗。",
    des2: "聯繫電話：",
    des3: "聯繫郵箱：",
  },
  // activationcode: {
  //   //兑换码页面
  //   title: "兑换码",
  //   describe: "请输入16位兑换码进行兑换",
  //   placeholder: "请输入兑换码",
  //   activationBtn: "立即兑换",
  //   service: "咨询客服",
  //   ruleTitle: "兑换码规则",
  //   rule1: "1、请先完成实名认证，仅支持年满18周岁的用户。",
  //   rule1: "2、输入正确的兑换码后，可获得对应数字资产。",
  //   rule1: "3、一个兑换码仅限兑换一次，不可重复使用。",
  //   status_text: "恭喜您兑换成功！",
  //   look_certificate: "查看证书",
  //   purchaseInstructionsP1: "数字证书说明",
  //   purchaseInstructionsP2: "请您务必审慎阅读 充分理解以下内容",
  //   p4Des1: "立足于通过数字证书进行商品防伪溯源，保护正版价值。",
  //   p4Des2: "数字证书不具备交易价值，仅为确权工具，不允许炒作。",
  //   p4Des3: "本数字证书不得用于炒作、场外交易和任何商业用途。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施，包含但不限于冻结账号等。",
  //   p4Des4: "请远离非理性炒作，防范欺诈风险。",
  //   p4Des5: "立足于通过数字证书进行商品防伪溯源，保护正版价值。",
  //   p4Des6: "数字证书不具备交易价值，仅为确权工具，不允许炒作。",
  //   p4Des7: "本数字证书可支持赠送，赠送程序需依据国家法律法规和政策不定期调整。",
  //   p4Des8: "本数字证书不得用于炒作、场外交易和任何商业用途。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施，包含但不限于冻结账号等。",
  //   p4Des9: "请远离非理性炒作，防范欺诈风险。",
  //   p4Des10: "立足于通过数字证书进行商品防伪溯源，保护正版价值。",
  //   p4Des11: "数字证书不具备交易价值，仅为确权工具，不允许炒作。",
  //   p4Des12: "为了防止炒作，本数字证书需至少持有达到",
  //   p4Des122: "天后可无偿赠送，赠送程序需依据国家法律法规和政策不定期调整。",
  //   p4Des13: "本数字证书不得用于炒作、场外交易和任何商业用途。如发现存在炒作等异常行为、涉嫌违法违规或协议禁止的行为，我们有权采取必要的限制措施，包含但不限于冻结账号等。",
  //   p4Des14: "请远离非理性炒作，防范欺诈风险。",
  //   refuseBtn: "取消",
  //   agreeBtn: "兑换",
  //   agreeBtn1: "兑换",

  // },
  bankAgreement: {
    //兑协议页面
  },
  blindbox: {
    //快速了解數字藏品頁面
    Noviceguide: "新手指南",
    commonProblem: "常見問題",
    blindboxDes1: "來薄盒，構建屬於自己的下一代可視化數字身份，開啟web3之旅！",
    blindboxDes2: "薄盒Mints為國內首個基於web3網絡框架，集可穿戴數字藏品與藏品應用場景於一體的入口。通過區塊鏈技術確權數字內容，提供可信存證技術、藏品數字憑證技術服務，通過生活中隨處可見的智能手機和電子屏，重新定義新的收藏方式。特別一提，薄盒除了致力於持續提升藏品消費和收藏互動體驗，更主力推動可視化數字身份體系的構建，和知名品牌聯合打造多面向可穿戴數字藏品。並以具有驚喜的盲盒形式為藏家們帶來不同的體驗。",
    blindboxDes3: "獨家正版授權，權威、可信賴！",
    blindboxDes4: "平台聚合開發頂流品牌資源，限量發行正版授權可穿戴的數字藏品。讓每個人都有機會擁有獨一無二的數字藏品，獲得更多平台或品牌專屬權益。在這裡，無論你是創作者還是數字藏品的收藏家，薄盒都會為您帶來更自由的選擇。為每一位用戶拓展更豐富更酷的玩法。",

    blindboxDes6: "什麼是下一代數字收藏",
    blindboxDes7: "下一代數字收藏，亦稱數字藏品2.0，薄盒Mints作為國內首家數字藏品2.0的開拓者，快速開啟數藏收藏應用時代，加快了行業創新與資源整合。讓藏品可應用於虛擬與現實，將各領域(電影、電視劇、綜藝、動漫、音樂、藝術品)且多元的優秀品牌鑄造成可應用的數字藏品，放入數字盲盒獨家限量發售，賦能成為在元宇宙中可穿戴的物件及可置換的全息場景空間，在無界限的數字世界裡享受創作、藏品展示、娛樂休閒、社交互動的深度體驗。 ",

    blindboxDes9: "打造獨一無二的元宇宙化身",
    blindboxDes10: "我們為每個用戶打造專屬於個人的數字身份並將其3D數字人化，在這裡獲得的所有數字藏品都將可能擁有可穿戴屬性，創建專屬於你的元宇宙數字人，將各種藏品穿戴在你的虛擬形像上，與好友分享炫耀數字世界或現實生活的數字時尚創意，讓元宇宙中的你被各領域知名品牌賦能，在現實和元宇宙中煥發新的生命力！",
    blindboxDes12: "AR投射將藏品融入現實生活",
    blindboxDes13: "通過優質的品牌資源讓多個內容組合，在物理世界之上建設一個平行的虛擬世界！打開AR攝像頭，將藏品放在真實世界中，創造數字技術帶來的全新造型風格並分享至各大社交平台，建立與眾不同的數字時尚情感鏈接，獲得物理與數字交融的雙重體驗。",
    blindboxDes131: "獲取元宇宙中的數字名片與成就",
    blindboxDes132: "不僅僅是虛擬形象的塑造，薄盒Mints特有的MNS（基於區塊鏈的可擴展和開放式化的命名系統）讓你擁有不可替代、不可重複的數字身份名片；POAP鏈上徽章把你在數字世界的成就、貢獻、興趣、活動相綁定，來證明你在元宇宙世界中的身份和位置，不但成為你數字資產的一部分也能幫你快捷找到屬於自己的同好，隨時隨地隨心交流，體驗元宇宙時代的全新社交體驗。",
    blindboxDes133: "為什麼要建立自己的數字身份？",
    blindboxDes134: "數字身份一直都是互聯網鏈接用戶與平台的唯一標識。Web1只讀時代，用戶通過賬號註冊獲取不具有實際用途的身份體系；“可讀可寫”的Web2階段，用戶在可通過註冊創建身份的同時，還能一鍵授權登錄創建身份。而隨著“可讀可寫且可擁有”Web3時代的到來，如數字藏品、3D數字人等成為了數字身份的新一代創建方式，也是通往不同虛擬空間的通行證。不僅如此，Web3時代下的數字身份可讓用戶完全擁有自己身份信息的所有權及產生數據的自主權。",
    blindboxDes135: "在這裡，收集可穿戴的數字藏品！ ",
    blindboxDes136: "因為數字藏品具有不可篡改、不可分割、不可複制的屬性以及不受題材、展示方式、現實物理法則約束的特性，所以它擁有無限的可能性。在未來，你可操作你由數字藏品組成的數字人在虛擬空間中與其他人聊天社交；也可以將影視劇中的服飾、道具、飾品等主題數字藏品著裝在數字人身上，讓你的數字人擁有猶如主角一般的形象，更可以擁有坐騎以及各種稀有交通工具數字藏品，讓你可以與之互動在虛擬空間中穿梭。除此之外，還可以擁有屬於自己的寵物數字藏品，陪伴你左右。現在，這一切正在逐步實現，薄盒Mints致力於實現數字藏品的每一種可能，把未來帶入現實。",
    blindboxDes137: "豐富多彩的藏品獲取方式",
    blindboxDes138: "在薄盒Mints您可以擁有多種獲取數字藏品的方式，可以通過開啟趣味盲盒、參與平台活動等多種形式來獲得數字藏品。目前平台所有的數字藏品僅支持人民幣支付，且只允許中國用戶購買。",
    blindboxDes139: "平台特有的藏品打開儀式",
    blindboxDes140: "比起直接購買已知內容物的數字藏品，盲盒形式讓收藏的過程充滿了驚喜和樂趣，通過購買盲盒的方式可以讓收藏者發現更多可能從未註意過或是限量珍藏的優質數字藏品，也可能獲得比盲盒本身價值更高的數字藏品。每個盲盒都是和品牌方聯合製造及取得官方授權，內含數字藏品皆屬於該主題藏品，購買盲盒更有機會獲得稀有款數字藏品。",
    blindboxDes14: "我們歡迎您，",
    blindboxDes15: "歡迎來到薄盒，更歡迎來到未來，",
    blindboxDes16: "在這裡成為獨一無二的數字藏品收藏家。",
    blindboxDes17: "如何購買數字藏品盲盒？",
    blindboxDes18: "通過“首頁”或“盲盒”導航頁面，進入盲盒詳情；",
    blindboxDes19: "等候室開放後點擊“加入等候室”，待盲盒發售時間，系統會自動隨機分配排隊號碼，用戶根據號碼進行排隊購買；",
    blindboxDes20: "進入購買頁面後，用戶完成支付，則可以直接打開盲盒獲取數字藏品，也可以後期在個人中心中完成開啟盲盒的操作；",
    blindboxDes21: "打開盲盒後立即獲得數字藏品，可以在“個人中心”裡隨時看到已經獲得的數字藏品。",
    blindboxDes22: "目前僅支持人民幣購買，支持使用微信或支付寶支付。目前只允許中國用戶購買。針對盲盒和數字藏品的交易過程會記錄在區塊鏈上，所以概不支持退款。",
    blindboxDes23: "如何創建自己的元宇宙3D數字人？",
    blindboxDes24: "目前數字人系統僅支持薄盒Mints App內創建並查看。下載薄盒App並完成註冊後，點擊個人中心自動跳轉創建數字人的界面，選擇性別點擊下一步，完成捏臉並保存，即可擁有專屬數字人。",
    blindboxDes25: "如何調整數字人穿戴及造型？",
    blindboxDes26: "成功擁有數字人之後，點擊進入個人中心看到選擇數字人邊上的",

    blindboxDes27: "按鈕，進入數字人衣櫃。進入之後可以選擇已獲得的所有可穿戴數字藏品穿戴在數字人身上。右上角選擇",
    blindboxDes28: "按鈕可進入捏臉頁面，調整數字人形象。選擇右下角",
    blindboxDes29: "按鈕可更換數字人性別或已獲得的其他角色形象。",
    blindboxDes30: "MNS是什麼？",
    blindboxDes31: "「MNS」是Mints Name Service縮寫，它是一個基於區塊鏈技術的可擴展命名系統，主要服務於用戶可讀區塊鏈地址映射名稱，讓人們沒有必要再复製或輸入冗長的區塊鏈地址來作為訪問的鏈接或身份標識內容。每一枚「MNS」本身也將會是一個獨一無二的數字藏品，具有數字藏品屬性。 ",
    blindboxDes32: "積分是什麼？",
    blindboxDes33: "在平台購買盲盒或者參與活動都會獲得相應的積分。目前積分功能還未全面上線，具體使用方式和規則會在後續逐步更新。",
    blindboxDes35: "POAP是什麼?",
    blindboxDes36: "POAP也稱“出勤證明協議”，它將會是你在元宇宙世界中的出行見證，每一枚POAP皆是通過特別設計的徽章，用戶可以通過POAP來證明自己的鏈上行為並永恆記錄在時間戳上，讓用戶之間可以快捷的找到屬於自己的同好。在未來POAP更具極大可能性演變成有價值的收藏品。",
    blindboxDes37: "如何贈送藏品",
    blindboxDes38: "部分數字藏品支持贈送，在購買時會在盲盒詳情中標註是否支持贈送。請注意查看；",
    blindboxDes39: "如數字藏品可贈送，在數字藏品的商品頁面，選擇贈送按鈕，填寫需要贈送的人的手機號及信息將頁面轉發給即可。被贈人點擊註冊後即可領取贈品。"
  },
  infiniteBoxDetail: {
    buy: "立即購買",
    moreBuy: "剩餘最多購買數量",
    count: "數量",
    selectCount: "選擇數量",
    youzan: {
      text: "下單支付成功後，請前往個人中心查看我的盲盒。",
      btn: "關閉",
      btn2: "去查看",
    }
  },
  public: {
    money: '$',
    endLine: '這是我的底線',
    qx: '取消',
    qr: '確認',
    qd: '確定',
    recommendenTitle: "您有可能獲得",
  },
  boxDetail: {
    joinRoomSucc: "加入等候室成功！",
    uMost: "您最多可",
    timeOut: "超時，請重新排隊",
    waive: "放棄",
    continue: "繼續",
    isWaive: "是否放棄",
    isWaive2: "？放棄後需要重新排隊。",
    now: "立即",
    selectCount: "選擇數量",
    moreBuy: "剩餘最多",
    count: "數量",
    a: "個",
    //盲盒詳情頁面
    yy: "已有",
    rcyhd: "人參與活動",
    lj: "立即",
    lq: "領取",
    gm: "購買",
    qmhy: "前面還有",
    rzzpdgm: "人正在排隊購買",
    y: "已",
    lw: "領完",
    sq: "售罄",
    kq: "開啟",
    qs: "起售",
    isshowlastcount: "剩餘",
    isshowtotalcount: "總數",
    money: "￥",
    waitingRoomCount: "已有人參與活動",
    showQueueModel: "查看隊列詳情",
    timerExpireVal: "立即購買",
    timeInterval2: "距加入等候室",
    timeInterval: "距活動開始",
    sort: "前面還有人正在排隊購買",
    joinWaitingRoom: "加入等候室",
    NumberFenpei: "號碼分配中",
    realTimeTitle: "活動時間",
    beijingStartwaittime: "等候室開放",
    beijingStartTime: "盲盒開售",
    beijingStartTime1: "盲盒領取",
    realTimeTitle2: "盲盒詳情",
    detailTipsTitle: "數字藏品小貼士",
    tipsCon: "在區塊鏈技術的支持下，繪畫、視頻、模型、門票等任何種類的數字商品都可以被確權，即擁有了一張專屬自己的“數字身份證”，這個獨一無二的數據內容會永久的保存在區塊鏈上，讓數字商品可以被擁有並承載其獨特的價值。",
    tipsCon1: "薄盒數字藏品是基於「樹圖區塊鏈」技術協議的數字商品，每個數字藏品在「樹圖區塊鏈」上都擁有唯一的標識，永久存儲並且同樣擁有不可篡改、不可分割的特性。 「樹圖區塊鏈」為數字藏品的收藏提供區塊鏈底層技術支持，為平台提供可信存證擴展、數字商品確權技術。 ",
    tipsCon1Text: "注意事項",
    tipsCon1Text2: "*請先完成實名認證，再進行購買",
    tipsCon1Text3: "*因為數字藏品的特殊性，不能篡改，一旦銷售不支持退換",
    recommendenTitle: "您有可能獲得",
    modal: "訂單尚未支付，是否繼續支付？",
    modalOkText: "取消訂單",
    modalCancelText: "繼續支付",
    notStardTitleIsFree1: "活動開始，您已加入領取隊列",
    notStardTitleIsFree0: "活動開始，您已加入購買隊列",
    rzzpd: "人正在排隊",
    BuyersText: "暱稱",
    priceText: "隊列號",
    codeText: "狀態",
    hy: "還有",
    wyhzpdz: "位用戶在排隊中···",
    pendingInfo1: "*注：當其他⽤戶領取盲盒時，有",
    pendingInfo2: "秒",
    pendingInfo3: "領取時間，在此期間內您的隊列排名不會發⽣變化，當其他⽤戶領取結束後隊列排名會進⾏刷新。",
    pendingInfo4: "*注：當其他⽤戶進行購買時，有",
    pendingInfo5: "下單時間，在此期間內您的隊列排名不會發⽣變化，當其他⽤戶購買結束後隊列排名會進⾏刷新。",
    Leave1: "離開隊列",
    Leave2: "離開後您將失去",
    Leave3: "機會",
    qr: "確認",
    qx: "取消",
    waitingTipsPo1: "活動開始前，請提前加入等候室等待。",
    waitingTipsPo2: "活動開始時，我們會優先為已經在等候室內的所有在線用戶隨機分配號碼，按號碼順序進入完成",
    waitingTipsPo3: "如果在活動開始後加入等候室，則會按照現有最大排隊號碼 +1。",
    purchaseInstructions1: "須知",
    purchaseInstructions2: "請您務必審慎閱讀 充分理解以下內容",
    purchaseInstructions3: "數字藏品為虛擬數字商品，而非實物，僅限經實名認證為年滿18周歲的用戶",
    purchaseInstructions4: "本商品一經",
    purchaseInstructions5: "，不支持退換。",
    purchaseInstructions6: "數字藏品的版權由發行方或創作家擁有，除另行取得版權擁有者書面同意外，用戶不得將數字藏品用於任何商業用途。",
    purchaseInstructions7: "數字藏品暫不支持交易。",
    purchaseInstructions8: "本數字藏品不得用於炒作、場外交易。如發現存在炒作等異常行為、涉嫌違法違規或協議禁止的行為，我們有權採取必要的限制措施；包含但不限於凍結賬號等。",
    purchaseInstructions9: "請遠離數字藏品非理性炒作，防範欺詐風險。",
    jj: "拒絕",
    ty: "同意",
    xhtcp1: "銷毀說明",
    xhtcp2: "本次在2個月內未銷售完的數字藏品將會自動銷毀。以保證已發售的數字藏品均是被用戶所認可的。",
    xhtcp3: "知道了",
    leaveModalContent: "離開後您將失去購買機會，您確認離開隊列嗎？",
    leaveModalContent2: "離開後您將失去領取機會，您確認離開隊列嗎？",
    slbnwk: "請選擇購買個數",
    mhyxj: "盲盒已下架",
    pendingListStatus: {
      1: "排隊中",
      2: "購買中",
      3: "支付中",
    },
    pendingListStatus2: {
      1: "排隊中",
      2: "領取中",
      3: "領取中",
    },
  },
  boxList: {
    //盲盒列表頁面
    status4FalseType1: "出售中",
    status4FalseType2: "進行中",
    status4FalseType3: "領取中",
    status4TrueType1: "已售罄",
    status4TrueType2: "已結束",
    status4TrueType3: "已領完",
    loadText: "沒有找到相關數據",
    loadText2: "暫無更多數據",
    newBox: "新盒推薦.",
    all: "全部",
    ing: "進行中",
    end: "已售罄",
  },
  certificateFreeBox: {
    //特殊盲盒頁面
    surplus: "個",
    isshowlastcount: "剩餘",
    isshowtotalcount: "總數",
    limitbuycount: "可領取盲盒數量：",
    getBox: "領取盲盒",
    timeInterval: "距活動開始",
    ylw: "已領完",
    hdsj: "活動時間",
    dhskf: "等候室開放：",
    kq: "開啟",
    mhlq: "盲盒領取：",
    lq: "領取",
    kf: "開放",
    mhxq: "盲盒詳情",
    szscpxts: "數字藏品小貼士",
    tipsCon: "在區塊鏈技術的支持下，繪畫、視頻、模型、門票等任何種類的數字商品都可以被確權，即擁有了一張專屬自己的“數字身份證”，這個獨一無二的數據內容會永久的保存在區塊鏈上，讓數字商品可以被擁有並承載其獨特的價值。",
    tipsCon1: "薄盒數字藏品是基於「樹圖區塊鏈」技術協議的數字商品，每個數字藏品在「樹圖區塊鏈」上都擁有唯一的標識，永久存儲並且同樣擁有不可篡改、不可分割的特性。 「樹圖區塊鏈」為數字藏品的收藏提供區塊鏈底層技術支持，為平台提供可信存證擴展、數字商品確權技術。 ",
    tipsCon1Text: "注意事項",
    tipsCon1Text2: "*請先完成實名認證，再進行購買",
    tipsCon1Text3: "*因為數字藏品的特殊性，不能篡改，一旦銷售不支持退換",
    recommendenTitle: "您有可能獲得",
    lqxzp1: "領取須知",
    lqxzp2: "請您務必審慎閱讀 充分理解以下內容",
    lqxzp3: "數字藏品為虛擬數字商品，而非實物，僅限經實名認證為年滿18周歲的用戶領取。",
    lqxzp4: "本商品一經領取，不支持退換。",
    lqxzp5: "數字藏品的版權由發行方或創作家擁有，除另行取得版權擁有者書面同意外，用戶不得將數字藏品用於任何商業用途。",
    lqxzp6: "數字藏品暫不支持交易。",
    lqxzp7: "本數字藏品不得用於炒作、場外交易。如發現存在炒作等異常行為、涉嫌違法違規或協議禁止的行為，我們有權採取必要的限制措施；包含但不限於凍結賬號等。",
    lqxzp8: "請遠離數字藏品非理性炒作，防範欺詐風險。",
    refuseBtn: "拒絕",
    agreeBtn1: "同意",
    xhtcp1: "銷毀說明",
    xhtcp2: "本次在2個月內未銷售完的數字藏品將會自動銷毀。以保證已發售的數字藏品均是被用戶所認可的。",
    xhtcp3: "知道了",
    nzdklq: "您最多可領取",
    fen: "個",
    slbnwk: "請選擇購買個數",
    nzwlqzg: "暫無領取資格",


  },
  creatorDetail: {
    //創作家詳情頁面
    loadText: "沒有找到相關數據",
    loadText2: "暫無更多數據",
  },
  creatorList: {
    //創作家列表頁面
    loadText: "沒有找到相關數據",
    loadText2: "暫無更多數據",
  },
  freeSuccess: {
    //領取盲盒成功頁面
    successDesc: "領取成功",
    lookDetail: "查看",
    contentText: "秒後跳轉至盲盒開啟頁面"
  },

  getBoxSuper: {
    //超能一家人打開盲盒頁面
    laterOpen: "前往個人中心",
    Dropnum1: "盲盒掉落",
    Dropnum2: "個藏品",
    laterOpen2: "稍後打開",
    openBoxBtn: "打開盲盒",
    imgLabelimg: "保存圖片"
  },
  getGift: {
    //領取藏品頁面
    goShow3DPage: "3D空間",
    giveMessageInfo1: "贈送人",
    leaveMessageDiv: "好友給您的留言",
    nowReceive: "立即領取",
    isFiled: "領取失敗",
    okText: "關閉",
    cancelText: "回首頁",
  },
  giftLogin: {
    //領取藏品登錄頁面
    loginText: "請輸入您的手機號",
    loginText2: "登錄或註冊您的薄盒賬號",
    placeholder1: "請輸入手機號",
    getCode: "獲取驗證碼",
    yzm: "驗證碼",
    placeholder2: "請輸入6位短信驗證碼",
    login: "登錄",
    changeCheck: "未註冊手機驗證通過後自動登錄，註冊即表示同意",
    agreement: "《薄盒用戶協議》",
    and: "和",
    conceal: "《隱私政策》",
    noCheckText: "請閱讀並勾選頁面協議",
    isSHowBtn: "我已閱讀並同意",
    sendMessage: "發送成功",
    telText: "請填寫手機號",
    yzmText: "請填寫驗證碼",
  },
  giveGift: {
    //贈送藏品頁面
    phoneText: "獲贈人",
    MNSPlaceholder: "請輸入獲贈人MNS/地址",
    telPlaceholder: "請輸入獲贈人的手機號",
    leaveMessageDiv: "留言",
    msgPlaceholder: "請輸入您給獲贈人的留言（非必填）",
    reminderTips1: "溫馨提示：",
    reminderTips2: "1、請認真核對受贈人的手機號信息，如填寫錯誤對方將無法領取。",
    reminderTips22: "2、該數字藏品在受贈滿",
    reminderTips23: "天后，可再次發起贈送。",
    confirmBrn: "取消",
    sureGive: "贈送",
    okText: "否",
    cancelText: "是",
    isRegister1: "該用戶未在平台註冊！請告知好友使用",
    isRegister2: "的手機號領取",
    copySuccess: "複製成功,快去粘貼給你的好友吧！",
    navName1: "MNS/地址",
    navName2: "手機號",
    text1: "（非必填）",
    text2: "2、本數字藏品受贈後即可贈送。",
    text3: "確認贈送",
    text4: "輸入操作密碼",
    text5: "忘記密碼？使用",
    text6: "短信驗證",
    text7: "該手機號尚未註冊薄盒，若你確認贈送，我們將通過短信通知對方接收",
    text8: "該數字藏品是否確認贈送給用戶",
    text9: "請輸入正確的手機號格式",
    text10: "請輸入MNS/地址",
    text11: "請輸入手機號",
  },
  giveSuccess: {
    //贈送藏品成功頁面
    successText: "贈送成功",
    timeText: "秒後跳轉藏品詳情頁面"
  },
  index: {
    //首頁面
    giftsCon: "收到來自",
    toMY: "點擊查看",
    Newboxrec: "新盒推薦",
    lookMore: "查看更多",
    digital: "數字證書",
    creator: "創作家",
    internet: {
      title: "溫馨提示",
      text1: "1. 數字藏品為虛擬數字商品，而非實物，僅限經實名認證為年滿18周歲的用戶購買。 ",
      text2: "2. 本商品一經出售，不支持退換。  ",
      text3: "3. 數字藏品暫不支持交易。",
      text4: "4. 數字藏品不得用於炒作、場外交易。如發現存在炒作等異常行為、涉嫌違法違規或協議禁止的行為，我們有權採取必要的限制措施；包含但不限於凍結賬號等。",
      text5: "5. 合理評估風險識別能力和風險承擔能力，理性參與數字藏品，請遠離數字藏品非理性炒作，防範欺詐風險。",
      btn: "知道了",
    },
    jayModel: {
      title: "#杰倫元宇宙演唱會#",
      title2: "提示",
      num: "人",
      text: "想看薄盒與杰倫共同舉辦元宇宙演唱會，請進入音樂空間進行“點贊”。當點贊達到18:00時，我們將打開新的大門。",
      text2: "請下載APP前往音樂空間點贊並體驗",
      btn: "去點贊",
      btn2: "去下載",
    }
  },
  login: {
    //登錄頁面
    title: "登錄註冊",
    tel: "手機號",
    telPlaceholder: "請輸入手機號",
    getCode: "獲取驗證碼",
    yzmtitle: "驗證碼",
    yzmPlaceholder: "請輸入6位短信驗證碼",
    getCode: "獲取驗證碼",
    login: "登錄",
    changeCheck: "未註冊手機驗證通過後自動登錄，註冊即表示同意",
    agreement: "《薄盒用戶協議》",
    and: "和",
    conceal: "《隱私政策》",
    noCheckText: "請閱讀並勾選頁面協議",
    isSHowBtn: "我已閱讀並同意",
    sendSuccess: "發送成功",
    placeTel: "請填寫手機號",
    placeYzm: "請填寫驗證碼"
  },
  lotterCode: {
    //抽籤碼盲盒頁面
  },
  openBox: {
    //打開盲盒後藏品展示頁面
    showText: "查看全部藏品"
  },
  openBoxSuper: {
    //超能一家人打開盲盒後藏品展示頁面
    laterOpen1: "前往個人中心",
    downloadBase64Img: "保存圖片",
    downloadBase64Text: "長按保存圖片",
  },
  openMyBox: {
    openBoxBtn: "返回個人主頁",
    creatorName: "創作家",
    tags: "類型",
    opusopusseriesName: "系列",
    timer: "時長",
    adownload: "微信不支持下載，請點擊右上角使用其它瀏覽器打開！",

  },
  page3D: {
    //3d展示頁面
  },
  payment: {
    //支付頁面
    dropNum1: "盲盒最多可能掉落",
    dropNum2: "個藏品",
    customerInfo1: "收貨人",
    customerInfo2: "支付金額",
    apliyCheckFn: "支付寶支付",
    bankCheckFn: "銀行卡快捷支付",
    surePayBtnFn: "確認支付",
    modal: "訂單尚未支付，是否繼續支付？",
    okText: "繼續支付",
    cancelText: "取消訂單",
    payResultModal: "您是否已完成本次支付？",
    okText2: "未支付",
    cancelText2: "我已支付",
    payResultSuccess: "支付中，請耐心等待！",
    payErrorText1: "訂單已超時，請重新下單",
    payErrorText2: "交易失敗",
  },
  paymentSuccess: {
    //支付成功頁面
    successDesc: "支付成功",
    mnsSuccess: "查看",
    orderInfo1: "訂單編號:",
    orderInfo2: "商品名稱:",
    orderInfo3: "實付金額",
    orderInfo4: "銀行卡優惠:",
    toIndex: "返回首頁",
    lookDetail: "查看",
    contentText1: "秒後打開盲盒",
    contentText2: "秒後返回",
    contentText3: "秒查看藏品",
  },
  payMiddle: {
    //支付結果跳轉頁面
    payStatus1: "支付成功",
    payStatus2: "返回 薄盒",
    payStatus21: "查看MNS",
    payStatus22: "開啟盲盒",
    payStatus3: "支付失敗",
    payStatus4: "返回 薄盒 重新支付",
  },
  receive: {
    //證書頁面
    creatorName: "創作家：",
    confluxaddress: "合約地址：",
    confluxname: "區塊鏈：",
    ownername: "持有者：",
    nftid: "藏品ID：",
    have: "已擁有該系列藏品",
    lookInfo: "查看詳情",
    noHave: "您暫未擁有該系列藏品",
    goService: "諮詢客服",
    receiveAlertTit: "溫馨提示",
    receiveAlertText: "該賬號下未查詢到相關數字證書，",
    receiveAlertText2: "請稍後再試！",
    receiveAlertConfirm: "確認",
    purchaseInstructionsTit: "數字證書說明",
    purchaseInstructionsText1: "立足於通過數字證書進行商品防偽溯源，保護正版價值。",
    purchaseInstructionsText2: "數字證書不具備交易價值，僅為確權工具，不允許炒作。",
    purchaseInstructionsText3: "本數字證書不得用於炒作、場外交易和任何商業用途。如發現存在炒作等異常行為、涉嫌違法違規或協議禁止的行為，我們有權採取必要的限制措施，包含但不限於凍結賬號等。",
    purchaseInstructionsText4: "本數字證書可支持贈送，贈送程序需依據國家法律法規和政策不定期調整。",
    purchaseInstructionsText5: "請遠離非理性炒作，防範欺詐風險。",
    refuseBtn: "取消",
    agreeBtn: "領取",
    purchaseInstructions2Tit: "領取須知",
    purchaseInstructions2Text1: "請您務必審慎閱讀 充分理解以下內容",
    purchaseInstructions2Text2: "數字藏品為虛擬數字商品，而非實物，僅限經實名認證為年滿18周歲的用戶領取。",
    purchaseInstructions2Text3: "本商品一經領取，不支持退換。",
    purchaseInstructions2Text4: "數字藏品的版權由發行方或創作家擁有，除另行取得版權擁有者書面同意外，用戶不得將數字藏品用於任何商業用途。",
    purchaseInstructions2Text5: "數字藏品暫不支持交易。",
    purchaseInstructions2Text6: "本數字藏品不得用於炒作、場外交易和任何商業用途。如發現存在炒作等異常行為、涉嫌違法違規或協議禁止的行為，我們有權採取必要的限制措施；包含但不限於凍結賬號等。",
    purchaseInstructions2Text7: "請遠離數字藏品非理性炒作，防範欺詐風險。",

  },
  sellingTime: {
    //藏品詳情頁面
    opusattrcustomerName: "擁有者",
    customersellerName: "贈送人",
    saleWorkModal: "出售",
    undercarriage: "下架",
    giveGift: "贈送",
    givingGift: "贈送中",
    // modal
    okText: "繼續支付",
    cancelText: "取消訂單",
  },
  setUp: {
    //setUp頁面
    xmrz: "實名認證",
    wrz: "未認證",
    yrz: "已認證",
    dhm: "兌換碼",
    yhkgl: "銀行卡管理",
    jfye: "積分/餘額",
    operatingPass: "操作密碼"
  },
  VerificationInformation: {
    //区块链查证信息页面
  },
  wallet: {
    //钱包页面
  },
  workDetail: {
    //workDetail页面
  },
  //添加銀行卡
  addBank: {
    addBankText1: "綁定銀行卡",
    addBankText: "確認綁定銀行卡",
    cardNum: "卡號",
    careNumPlcae: "銀行卡號",
    caredName: "姓名",
    cardNamePlace: "開卡姓名",
    IDName: "身份證號",
    IDNamePlace: "銀行預留身份證號",
    phone: "手機號",
    phonePlcae: "銀行預留手機號",
    code: "驗證碼",
    codePlcae: "短信驗證碼",
    getCode: "獲取驗證碼",
    openPay: "確認開戶",
    agree: "接受",
    payAgreement: "《薄盒支付服務協議》",
    IncardNum: "請輸入銀行卡號",
    InCardName: "請輸入開卡姓名",
    InCardIdNum: "請輸入銀行預留身份證號",
    InCardPhone: "請輸入銀行預留手機號",
    sendSuccess: "發送成功",
    pleaseReadAggrement: "請閱讀並勾選銀聯用戶相關服務協議",

  },
  //銀行卡列表
  bankList: {
    bankCardPay: "銀行卡付款",
    payName: "商戶名稱 北京擘盒科技有限公司",
    please: "請在",
    complatedPay: "內完成支付",
    chooseBank: "選擇銀行卡",
    addBank: "添加銀行卡",
    goPay: "確認支付",
    setPwd: "請先設置支付密碼",
    confirm: "取消",
    goSet: "去設置",
    isComplatePay: "您是否已完成本次支付？",
    noPay: "未支付",
    isPay: "我已支付",
    payStatus: "支付中，請耐心等待！",
    bankUpper: "銀行卡數量已達上限",
    orderTimeOut: "訂單已超時，請重新下單",
    payError: "交易失敗",
  },
  //銀行卡管理
  bankManage: {
    bankManage: "銀行卡管理",
    noBank: "暫無可用銀行卡",
    removeBind: "解除綁定",
    isRemoveBind: "是否解除綁定",
    removeTips: "解除綁定後，將無法使用該銀行卡在平台進行支付",
    Sure: "確定",
    confirm: "取消",
    operationSuccess: "操作成功",
    bankNumUpper: "銀行卡數量已達上限"
  },
  //免費邀請盲盒
  freeBox: {
    activityStart: "距活動開始時間",
    activityEnd: "距活動結束時間",
    leadBoxNum: "您當前可領的盲盒數：",
    InvitePerson: "邀請新用戶註冊，可獲取更多盲盒",
    goInvite: "去邀請",
    nowReceive: "立即領取",
    isgone: "已領完",
    activityTime: "活動時間",
    activityTimeDes: "活動開啟：",
    activityTimeDesSpan: "開啟",
    activityTimeDes1: "活動結束：",
    activityTimeDes1Span: "結束",
    boxDetailText: "盲盒詳情",
    receivingInstructions: "領取須知",
    receivingInstructionsDes1: "請您務必審慎閱讀 充分理解以下內容",
    receivingInstructionsDes2: "數字藏品為虛擬數字商品，而非實物，僅限經實名認證為年滿18周歲的用戶領取。",
    receivingInstructionsDes3: "本商品一經領取，不支持退換。",
    receivingInstructionsDes4: " 數字藏品的版權由發行方或創作家擁有，除另行取得版權擁有者書面同意外，用戶不得將數字藏品用於任何商業用途。",
    receivingInstructionsDes5: "數字藏品暫不支持交易。",
    receivingInstructionsDes6: "本數字藏品不得用於炒作、場外交易。如發現存在炒作等異常行為、涉嫌違法違規或協議禁止的行為，我們有權採取必要的限制措施；包含但不限於凍結賬號等。",
    receivingInstructionsDes7: "請遠離數字藏品非理性炒作，防範欺詐風險。",
    receivingInstructionsDes8: "拒絕",
    receivingInstructionsDes9: "同意",
    destoryDesTitle: "銷毀說明",
    destoryDes1: "本次在2個月內未銷售完的數字藏品將會自動銷毀。以保證已發售的數字藏品均是被用戶所認可的。",
    destoryDes2: "知道了",
    InviteDesCon: "邀請好友註冊領取更多盲盒",
    InviteDesCo1: "每邀請1個好友註冊，即可額外領取1個盲盒",
    nowInvite: "立即邀請",
    maxInvite: "您最多可領取",
    maxInvite1: "個",
    setTimeText: "天:時:分:秒",
    boxOff: "盲盒已下架",
  },
  //kyc認證
  kyc: {
    btnText1: '開始認證',
    btnText2: '稍後再去',
    authenticationError: "身份認證失敗！",
    authenticationNum: "今日剩餘認證次數：",
    frequency: "次",
    reUpload: "重新上傳",
    return: "返回",
    authenticationSuccess: "身份認證通過！",
    complete: "完成",
    LV1Text: "Lv1身份認證",
    LV1TextText: "通過Lv1身份認證  即可參與盲盒活動",
    LV1Text1: "人臉識別",
    LV1Des1: "創建你的數字身份",
    LV1Des2: "數字身份基於區塊鏈地址，按照法律法規要求，需要用戶提供身份信息，請填寫真實、有效的信息。",
    LV1Des3: "實名認證後即可自動創建區塊鏈地址，請確認註冊手機號與實名信息匹配。",
    reallyName: "真實姓名",
    namePlace: "請輸入您的真實姓名",
    getCode: "獲取驗證碼",
    Next: "下一步",
    cardType: "證件類型",
    cerdNum: "證件號碼",
    cerdNumPlace: "請輸入您的證件號碼",
    IKnow: "我已閱讀並同意",
    userAgreement: "《用戶協議》",
    and: "和",
    privacyPolicy: "《隱私政策》",
    pleaseSure: "請確保為",
    myOperation: "本人操作",
    operationDes1: "請在明亮光線環境下錄製",
    operationDes2: "請在錄製過程中眨眼3-5次",
    operationDes3: "錄製時長3-5秒",
    operationDes4: "開始錄製視頻",
    operationDes5: "檢測中，請耐心等待",
    operationDes6: "視頻長度和手機的網絡速度會影響檢測時間",
    operationDes7: "確認",
    operationDes8: "請閱讀並勾選頁面協議",
    passedLV1: "該賬號已通過Lv1身份認證",
    confirm: "確認",
    choose: "請選擇",
    cardError: "身份證信息填寫有誤",
    IDcard: "身份證",
    passIdCard: "港澳台通行證",
    passIdCard1: "外國人永久居留身份證",
    passIdCard2: "定居國外的中國公民護照"
  },
  //域名購買
  mns: {
    buyMns: "購買MNS",
    curNoMns: "當前暫無可用MNS",
    whatMns: "什麼是MNS",
    nowUseMns: "當前使用的MNS",
    noMnsText: "當前暫無可用域名，快去購買吧～",
    noText: "暫無數據",
    isChangeNowUseMns: "是否切換當前使用的MNS？",
    Sure: "確認",
    Confirm: "取消",
    Obtained: "已獲得",
    UnderReview: "審核中",
    PurchaseFailed: "購買失敗",
    changeSuccess: "切換成功！",
    mnsBuy: "MNS購買",
    payMoney: "應付金額：",
    apliyPay: "支付寶支付",
    bankPay: "銀行卡支付",
    surePay: "確認支付",
    isContinuePay: "訂單尚未支付，是否繼續支付？",
    continuePay: "繼續支付",
    concelOrder: "取消訂單",
    isComplatePay: "您是否已完成本次支付？",
    noPay: "未支付",
    hasPay: "我已支付",
    transactionFailure: "交易失敗",
    payWait: "支付中，請耐心等待！",
    payError: "交易失敗",
    orderTimeOut: "訂單已超時，請重新下單",
  },
  //支付
  pay: {
    consignee: "收貨人",
    payMoney: "支付金額",
    apliyPay: "支付寶支付",
    weichatPay: "微信支付",
  },
  myCenter: {
    zdl: "知道了",
    kfMail: "郵箱：info@mints.cn",
    kf: '聯繫客服',
    followList: "關注列表",
    beConcerned: "被關注",
    Concerned: "關注",
    all: "全部",
    noCareText: "暫無被關注",
    collectionsNum: "藏品數量：",
    care: "關注",
    hasCare: "已關注",
    crossCorrelation: "互關",
    Huiguan: "回關",
    noCareText1: "暫無關注",
    isSureConfim: "是否確認取消關注",
    yes: "是",
    no: "否",
    closeSuccess: "取關成功！",
    careSuccess: "關注成功！",
    Collection: "藏品",
    Blindbox: "盲盒",
    filter: "篩選",
    noBoxText: "暫無相關盲盒",
    drop: "掉落",
    individual: "個藏品",
    noBoxText1: "暫無相關藏品",
    serialnumber: "藏品序號",
    label: "標籤",
    putaway: "收起",
    open: "展開",
    reset: "重置",
    sure: "確定",
    filteredForYou: "已為您篩選出",
    Articleresults: "條結果",
    myMns: "我的MNS",
    whatMns: "什麼是MNS",
    mnsDes1: "MNS是Mints Name Service縮寫，它是一個基於樹圖區塊鏈的可擴展和開放式化的命名系統，主要服務於用戶可讀區塊鏈地址映射名稱，旨在為用戶提供簡短易讀的名稱，可通過購買獲得。",
    mnsDes2: " MNS是你的“元宇宙”起點，是屬於每個人的數字身份名片，它會連接你在數字世界中的成就、貢獻、興趣和活動，一旦擁有它，它就會和你的區塊鏈地址綁定，成為你數字資產的一部分。",
    mnsDes3: " 1、獲得MNS之後可以綁定自己的區塊鏈地址。",
    mnsDes4: "2、用戶需先完成實名認證，再進行購買。每個用戶都可以通過搜索欄檢索尋找想要購買的MNS，如此前未有人註冊過，您即可發起購買，支付完成後進入審核階段。",
    mnsDes5: "3、MNS可以是26個英文字母及10個阿拉伯數字任意順序組成，現階段可購買至少要用7個字符組成，並會自動在組合文字後面添加“.mints”的後綴，如“ab12.mints”。",
    mnsDes6: " 4、所有MNS購買前都需要完成審核，您設置的名稱不得侵犯或涉嫌侵犯他人的合法權益。設置名稱時遵守以下規定：",
    mnsDes7: "（1）名稱及其讀音、音譯、翻譯不得與黨和國家領導人或其他社會名人的真實姓名、字號、藝名、筆名相同；",
    mnsDes8: "（2）名稱及其讀音、音譯、翻譯不得與國家機構或其他機構的名稱相同；",
    mnsDes9: "（3）名稱及其讀音、音譯、翻譯不得包含歧視、侮辱、猥褻類詞語；",
    mnsDes10: "（4）名稱及其讀音、音譯、翻譯不得侵害有關馳名商標的權利；",
    mnsDes11: "（5）不設置易產生歧義、引起他人誤解的賬號的名稱；",
    mnsDes12: "（6）不得危害國家安全，洩露國家秘密，顛覆國家政權，破壞國家統一；",
    mnsDes13: "（7）不得損害國家榮譽和利益的，損害公共利益；",
    mnsDes14: "（8）不得煽動民族仇恨、民族歧視，破壞民族團結；",
    mnsDes15: "（9）不得破壞國家宗教政策，宣揚邪教和封建迷信；",
    mnsDes16: "（10）不得散佈謠言，擾亂社會秩序，破壞社會穩定；",
    mnsDes17: "（11）不得散佈淫穢、色情、賭博、暴力、兇殺、恐怖或者教唆犯罪；",
    mnsDes18: "（12）不得侮辱或者誹謗他人，侵害他人合法權益；",
    mnsDes19: "（13）不得違反憲法或法律法規規定；",
    mnsDes20: "（14）不得含有法律、行政法規禁止的其他內容。",
    mnsDes21: "如您設置的名稱涉嫌侵犯他人合法權益或者含有法律、行政法規等規範性文件、監管政策等禁止的內容，我們有權拒絕通過。",
    mnsDes22: "5、名稱通過審核後，用戶即可擁有此MNS的使用權。",
    mnsDes23: "6、你的好友可以通過名稱搜索關注你以及訪問你的空間。",
    mnsDes24: "7、若您已購買的MNS中包含涉嫌侵犯他人合法權益或者含有法律、行政法規等規範性文件、監管政策等禁止的詞彙或者該等詞彙的讀音、音譯、翻譯的，薄盒有權收回您已購買的MNS，在收回後您無權使用該MNS。我們對此不承擔任何責任，您將承擔因此產生的任何直接或間接損失及不利後果。",
    mnsDes25: "8、您理解並確認，因MNS不能篡改的特殊性，MNS一旦售出，不支持退換。",
    mnsDes26: "您理解並確認，薄盒有權根據國家法律法規、監管政策的變化或風險防範的需要對MNS的相關服務作出調整或更新，我們會以公告等通知方式就與MNS相關服務的更新向您進行提示。除通知中另有說明外，更新的內容將於更新公告公佈的生效之日起生效。若您不接受變更後的服務內容或功能，或不同意更新後的相關協議內容，您需立即停止使用相關服務。若您繼續使用薄盒提供的相關MNS服務的，即視為您已同意我們作出的變更，並自願接受變更後的協議內容約束。",
    mnsDes27: "購買MNS",
    nameCreater: "盲盒名稱/創作家",
    nameCode: "藏品名稱/創作家/系列/編號",
    confirm: "取消",
    noFound: "沒有搜索到相關",
    tryAnother: "換個搜索內容試試",
    InContent: "請輸入搜索內容",
    address: "地址:",
    Digitalcollection: "數字藏品",
    message: "消息",
    Digitalspace: "數字空間",
    More: "更多",
    careofficialAccount: "* 關注「薄盒」公眾號",
    downApp: "下載APP可享更多福利",
    copySuccess: "複製成功",
    loginSuccessLook: "登陸後可查看相關內容",
    mnsName: "MNS名稱/地址",
    allHistory: "全部搜索記錄",
    delHistory: "清除搜索記錄",
    isDelHistory: "歷史記錄清除後無法恢復，是否清除全部記錄",
    del: "清除",
    noSearchText: "暫無搜索數據",
    noRegister: "未註冊",
    buy: "購買",
    goPayText: "訂單尚未支付，是否繼續支付？",
    modalOkText: "取消訂單",
    modalCancelText: "繼續支付",
    orderConfirmSuccess: "訂單取消成功！",
    Domainoccupied: "域名被佔用",
    confirm: "取消",
    cover: "封面",
    inuse: "使用中",
    Savereplacement: "保存更換",
    replacementSuccess: "更換成功！",
    careAccount: "關注官方公眾號【薄盒】，最新資訊盡在掌握",
  },
  //超級一家人
  superFamily: {
    des1: "票房達到要求後，次日12點開啟數字超能力盲盒領取等候室，",
    des2: "13點正式開放領取",
    des3: "共10000個盲盒，領完為止",
    des4: "2021.1.30",
    des5: "獲得主題數字空間盲盒",
    des6: "前往個人中心",
    savePicture: "保存圖片",
    Longpresspicture: "長按保存圖片",
    copySuccessToFriend: "複製成功,快去粘貼給你的好友吧！"
  },
  wxLogin: {
    loginRegister: "登錄註冊",
    phone: "手機號",
    phonePlcae: "請輸入手機號",
    code: "驗證碼",
    codePlcae: "請輸入6位短信驗證碼",
    getCode: "獲取驗證碼",
    InvitationCode: "邀請碼",
    InvitationCodePlace: "必填，請輸入好友的邀請碼",
    login: "登錄",
    loginTip: " 未註冊手機驗證通過後自動登錄，註冊即表示同意",
    arrgement: "《薄盒用戶協議》",
    and: "和",
    Privacypolicy: "《隱私政策》",
    loginTip1: "請閱讀並勾選頁面協議",
    readagree: "我已閱讀並同意",
    sendSuccess: "發送成功",
    fillPhone: "請填寫手機號",
    fillCode: "請填寫驗證碼",
    fillInvitationCode: "請填寫邀請碼",
    loginSuccess: "登錄成功"
  },
  404: {
    noFind: "對不起，您訪問的頁面走丟了～",
    toIndex: "返回首頁"
  },

  //兌換碼
  activationcode: {
    activationcode: "兌換碼",
    activationcodeDes: "請輸入16位兌換碼進行兌換",
    activationcodePlace: "請輸入兌換碼",
    Redeemnow: "立即兌換",
    customerservice: "諮詢客服",
    rules: "兌換碼規則",
    rulesDes1: "1、請先完成實名認證，僅支持年滿18周歲的用戶。",
    rulesDes2: "2、輸入正確的兌換碼後，可獲得對應數字藏品。",
    rulesDes3: "3、一個兌換碼僅限兌換一次，不可重複使用。",
    exchangeSuccess: "恭喜您兌換成功！",
    ViewCertificate: "查看證書",
    digitalDes: "數字證書說明",
    digitalDes1: "請您務必審慎閱讀 充分理解以下內容",
    digitalDes2: "立足於通過數字證書進行商品防偽溯源，保護正版價值。",
    digitalDes3: "數字證書不具備交易價值，僅為確權工具，不允許炒作。",
    digitalDes4: " 本數字證書不得用於炒作、場外交易和任何商業用途。如發現存在炒作等異常行為、涉嫌違法違規或協議禁止的行為，我們有權採取必要的限制措施，包含但不限於凍結賬號等。",
    digitalDes5: "請遠離非理性炒作，防範欺詐風險。",
    digitalDes6: "本數字證書可支持贈送，贈送程序需依據國家法律法規和政策不定期調整。",
    digitalDes7: " 為了防止炒作，本數字證書需至少持有達到",
    digitalDes8: "天后可無償贈送，贈送程序需依據國家法律法規和政策不定期調整。",
    confirm: "取消",
    exchange: "兌換",
  },
  //組件
  //盲盒詳情
  boxIntro: {
    boxDetailText: "盲盒詳情",
    detailTipsTitle: "數字藏品小貼士",
    detailTipsDes1: "唯一編號",
    detailTipsDes2: "可信記錄",
    detailTipsDes3: "永久存證",
    detailTipsDes4: "不可篡改",
    tipsCon: "在區塊鏈技術的支持下，繪畫、視頻、模型、門票等任何種類的數字商品都可以被確權，即擁有了一張專屬自己的“數字身份證”，這個獨一無二的數據內容會永久的保存在區塊鏈上，讓數字商品可以被擁有並承載其獨特的價值。",
    tipsCon1: "薄盒數字藏品是基於「樹圖區塊鏈」技術協議的數字商品，每個數字藏品在「樹圖區塊鏈」上都擁有唯一的標識，永久存儲並且同樣擁有不可篡改、不可分割的特性。 「樹圖區塊鏈」為數字藏品的收藏提供區塊鏈底層技術支持，為平台提供可信存證擴展、數字商品確權技術。 ",
    tipsCon1Text: "注意事項",
    tipsCon1Text2: "*請先完成實名認證，再進行購買",
    tipsCon1Text3: "*因為數字藏品的特殊性，不能篡改，一旦銷售不支持退換",
    recommendenTitle: "您有可能獲得",
    tipsText1: "唯一編號",
    tipsText2: "可信記錄",
    tipsText3: "永久存證",
    tipsText4: "不可篡改",
  },
  //官方授權·樹圖區塊鏈技術支持·限量發行「
  officialAuthorization: {
    des1: "官方授權·樹圖區塊鏈技術支持·限量發行",
    des2: "品牌保障",
    des3: "官方授權",
    des4: "數字藏品由品牌方官方授權，在薄盒Mints平台獨家發行，盜版必究。",
    des5: "樹圖區塊鏈技術支持",
    des6: "薄盒Mints數字藏品是基於「樹圖區塊鏈」技術協議發行的數字商品，每個數字藏品在「樹圖區塊鏈」都有鏈上唯一標識，且不可複制、不可篡改、不可分割。 「樹圖區塊鏈」為數字藏品的發行交易提供區塊鏈底層技術支持，為薄盒Mints數字潮玩收藏平台提供可信存證技術、數字藏品憑證技術服務。 ",
    des7: "限量發行",
    des8: "平台內所有數字藏品均為限量、限時發售，每個發售的數字藏品均有獨一無二的所有權憑證，同時，平台將會致力於持續升級商品的消費和收藏體驗。"
  },
  //banner
  banner: {
    bannerText1: "了解薄盒",
    bannerText2: "數字藝術的時代已經到來，讓日常充滿藝術收藏的趣味並且與睜眼所見的生活相融為一體，已不再是遙不可及的。伴隨著數字藝術的潮流興起，運用區塊鏈不可逆、不可篡改的特性，薄盒與各領域的頂尖藝術創作者合作將每件藏品賦予獨一無二的身份證碼。在薄盒平台上，人人都有機會擁有官方認證的傳奇數字藝術品。",
    bannerText3: "除了讓藝術收藏成為零距離、無界限的新樂趣，薄盒也為創作者打造一個新時代的藝術交流平台。而數字藝術的崛起將重新定義藝術創作的價值與專屬限定的珍藏感。加入薄盒，您也可以成為前衛藝術收藏家。",
    return: "返回",
    activityStart: "距活動開始時間",
    activityEnd: "距活動結束時間",
    openTime: "距等候室開放時間",
    days: "天",
    hours: "小時",
    minutes: "分鐘",
    seconds: "秒",
  },
  //藏品詳情
  collectionDetails: {
    des1: "官方授權·樹圖區塊鏈技術支持·限量發行",
    info1: "技術信息",
    info2: "發行方",
    info3: "藏品ID",
    info4: "合約地址",
    info5: "區塊鏈",
    info6: "樹圖區塊鏈",
    info7: "藏品詳情",
    info8: "版本序號",
    info9: "收藏中",
    info10: "待投放",
    info11: "已銷毀",
    classfiy: "分類",
    series: "系列",
    slice: "片段",
    level: "等級",
    publishTime: "專輯發布",
    creator: "創作家",
    creatorBirthday: "創作家生日",
    creatorConstalltion: "創作家星座",
    purchaseInstructionsP1: "品牌保障",
    purchaseInstructionsP2: "官方授權",
    purchaseInstructionsP3: "數字藏品由品牌方官方授權，在薄盒Mints平台獨家發行，盜版必究。",
    purchaseInstructionsP4: "樹圖區塊鏈技術支持",
    purchaseInstructionsP5: "薄盒Mints數字藏品是基於「樹圖區塊鏈」技術協議發行的數字商品，每個數字藏品在「樹圖區塊鏈」都有鏈上唯一標識，且不可複制、不可篡改、不可分割。 「樹圖區塊鏈」為數字藏品的發行交易提供區塊鏈底層技術支持，為薄盒Mints數字潮玩收藏平台提供可信存證技術、數字藏品憑證技術服務。 ",
    purchaseInstructionsP6: "限量發行",
    purchaseInstructionsP7: "平台內所有數字藏品均為限量、限時發售，每個發售的數字藏品均有獨一無二的所有權憑證，同時，平台將會致力於持續升級商品的消費和收藏體驗。",
    copySuccess: "複製成功！"
  },
  //歷史交易記錄
  history: {
    history: "歷史記錄",
    buyer: "買家",
    price: "價格",
    code: "編號",
    timeText: "交易時間",
  },
  //推薦藏品
  recommend: {
    recommendWork: "推薦藏品",
    moneySymbol: "¥",
    rise: "起",
    saled: "個出售",
    noMsg: "暫無推薦藏品"
  },
  //confirm彈窗
  confirm: {
    tips: "提示"
  },
  //底部
  footer: {
    weixinCare: "微信關注",
    serviceNumber: "「薄盒」服務號",
    aboutUs: "關於我們",
    problems: "常見問題",
    concel: "隱私政策",
    agreement: "使用協議",
    Copyright: "Copyright © 2021 北京擘盒科技有限公司 京ICP備2021015762號",
    Copyright1: "京網信備11010521639830920018號"
  },
  //开盲盒
  // getBox: {
  //   boxDrop: "盲盒掉落",
  //   workNum: "個藏品",
  //   later: "稍後打開",
  //   open: "打開盲盒",
  //   saved: "盲盒已存入個人主頁",
  //   returnMyCenter: "返回个人中心",
  //   goBack: "返回上一页"
  // },
  getBox: {
    //打開盲盒頁面
    Dropnum1: "盲盒掉落",
    Dropnum2: "個藏品",
    laterOpen: "稍後打開",
    openBoxBtnAll: "批量打開",
    openBoxBtn: "打開盲盒",
    laterToastMessage: "盲盒已存入個人主頁"
  },
  //頭部
  header: {
    login: "登錄",
    signOut: "退出",
    logOut: "退出登錄",
    newBox: "新盒推薦",
    getMore: "了解更多",
    downApp: "下載App ",
    wallet: "錢包餘額",
    myCenter: "個人主頁",
    industry: "行業資訊",
    language: "多語言",
  },
  //kyc認證彈窗
  kycModal: {
    timesexhausted: "今日認證次數已用盡！",
    tomorrow: "明日再來",
  },
  //分享share
  share: {
    shareTo: "分享至",
    downFile: "下載文件",
    poster: "生成海報",
    copyLink: "複製鏈接",
    confirm: "取消",
    savePicture: "保存圖片",
    longSave: "長按保存圖片",
    copySuccess: "複製成功,快去粘貼給你的好友吧！",
    clickTopRight: "點擊右上角選擇好友分享",
    clickTopRight1: "點擊右上角選擇朋友圈分享",
    copySuccess: "複製成功",
    dontSuppot: "微信不支持下載，請點擊右上角使用其它瀏覽器打開！",
    weiChat: "微信",
    WechatMoments: "朋友圈",
    sina: "新浪微博",
  },
  //抽籤碼規則
  detailedRules: {
    text1: "抽籤碼規則",
    text2: "一、參與對象",
    text3: "薄盒平台註冊用戶",
    text4: "二、活動規則",
    text5: " 1、用戶在活動期間內進入抽籤活動頁面，在指定活動時間內完成登記，即可獲得一個抽籤碼；在活動指定時間內將活動頁面分享給其他用戶並獲得其助力，可獲得更多抽籤碼。",
    text6: "2、發簽結束後平台將在所有成功發放的抽籤碼中隨機抽取一定數量的中籤用戶，並於該活動頁面進行公示，領取到中籤碼的用戶即可成功獲得免費盲盒獎品。",
    text7: "3、同一用戶最多可有4個抽籤碼有機會中籤，若抽取到多個中籤碼屬於同一用戶，則領取盲盒時，可領取到多個盲盒。",
    text8: "4、為了保證活動公平，不同用戶ID，但存在下列情況的：同一個設備號、同一個身份認證信息、同一個支付信息等能判定為同一人的均視為同一用戶，同一用戶下，最多可獲得4個獎品。",
    text9: "5、獎單公示後，盲盒領取時間為3小時，超過領取時限後盲盒獎品將無法領取，視為用戶主動放棄中獎資格，薄盒平台不提供任何形式的補償。",
    text10: "三、特別說明",
    text11: "1、活動期間，為了保證活動公平，如發現用戶存在違規行為（包括但不限於作弊、刷單/量、虛假交易、網絡攻擊、或者損害其他用戶、薄盒平台及任何第三方合法權益的行為等），薄盒平台將有權撤銷用戶活動資格、取消全部抽籤碼及盲盒領取資格、暫定且限制薄盒平台服務（包括不限於薄盒平台上的其他形式的營銷活動等）。若您已領了活動獎品，則平台有權收回您所獲得的盲盒。用戶因輕信第三方導致的損失，由用戶自行負責。",
    text12: "2、由於互聯網技術等客觀因素，薄盒平台顯示的信息可能存在一定的滯後性或差錯，對此情景用戶知悉並了解。因此，由於排版錯誤或信息錯誤導致活動以不正確或明顯不合理的信息顯示時，薄盒平台有權取消該不正確或明顯不合理的盲盒訂單。",
    text13: "3、如出現不可抗力或情勢變更的情況（包括但不限於重大災害事件、活動受政府機關指令需要停止舉辦或調整的、活動遭受嚴重網絡攻擊或因係統故障需要暫定舉辦的）導致活動內容髮生變動（如活動規則變動、活動暫停或取消等），用戶同意薄盒平台不因此承擔任何責任。",
    text14: "4、薄盒平台有權隨時變更本規則說明，變更內容一經公示即生效，若您對本規則有任何疑問，請登錄至薄盒平台找線上客服諮詢。"
  },
  // 消息中心
  myMessage: {
    message: '消息',
    allRead: '全部已讀',
    view: '查看',
    sysMsg: '系統消息',
    sysAnnouncement: '系統公告',
    noMore: '沒有更多消息了',
    noMsg: '暫無消息',
    isAllRead: '是否標記全部已讀？ '
  },
  // 操作密码
  operatePass: {
    text1: '輸入當前操作密碼',
    text2_1: '忘記密碼？使用',
    text2_2: '短信驗證',
    text3: '獲取驗證碼',
    text3_1: '輸入驗證碼',
    text4: '驗證碼已經發送到您的手機：',
    text5: '驗證碼',
    text6: '後可重新獲取',
    text7: '下一步',
    text8: '設置成功',
    text9: '成功',
    text10: '操作密碼用於藏品贈送等操作',
    text11: '輸入新操作密碼',
    text12: '操作密碼',
    text13: '暫未設置操作密碼',
    text14: '設置操作密碼',
    text15: '驗證碼發送成功！ ',
    text16: '修改操作密碼',
    text17: '修改新的操作密碼',
    text18: '再次輸入新操作密碼',
    text19: '2次密碼輸入不一致！ ',
    text20: '密碼設置成功！ ',
    text21: '密碼修改成功！ ',
  },
  // 我的客服
  kfCode: {
    title: '我的客服',
    text1: '（長按保存二維碼）',
    text2: 'VIP客戶服務二維碼 微信掃碼添加專屬客服',

  },
  // 行业资讯
  industryInfo: {
    title: "行業資訊"
  },
  // 首页banner
  newBanner: {
    status1: '等候室開放 ',
    status2: '活動開始 ',
    status3: '活動進行中 ',
    status4: '活動已結束 ',
  },
  // 区块链查证信息
  cfxPage: {
    title: "區塊鏈查證信息",
    opusname: "藏品名稱",
    creatorname: "創作家",
    confluxaddr: "交易哈希",
    ing: "上鍊中...",
    blockhash: "區塊哈希",
    paytime: "時間戳",
    sender: "發送方",
    receiver: "接收方",
    contractaddr: "合約地址",
    status: "狀態",
    sussess: "成功",
    domain: "MNS名稱",
    name: "POAP名稱",
  },
  // 下载页面
  download: {
    text1: "薄盒致力於幫助用戶構建自己的下一代可視化數字身份，基於區塊鏈技術確權數字內容，提供可信存證技術、藏品數字憑證技術服務。",
    text2: "開發商：北京擘盒科技有限公司",
    text3: "版本號：",
    text4: "《隱私協議》",
    text5: "《薄盒用戶協議》",
    text6: "點擊右上角選擇瀏覽器打開",
    text7: "如瀏覽器打開失敗，請移步桌面直接打開應用",
  },
  //poapRule
  poapRule: {
    title: "什麼是POAP？",
    text1: "POAP 數字成就徽章是一種可信記錄生活經歷的新方式，是基於區塊鏈上的一種出席證明協議，也是一種通過創造數字紀念品來記錄特定事件的協議。",
    text2: "每個 POAP 都是發行方送給收藏家的禮物，以慶祝特殊的共享記憶，證明自己親身經歷過這些“歷史性”活動。",
    text3: "通過將這些記憶鑄造到區塊鏈中，這些記憶是不可替代、不可篡改的。",
    text4: "1、POAP是獨特的數字藏品。",
    text5: "2、平台會不定期創建活動，你可以通過參與相關活動事件獲得POAP。",
    text6: "3、POAP通過智能合約自動觸發發放。",
    text7: "4、你獲得POAP後，不支持轉移、售賣。",
    text8: "5、你可以在個人中心展示、查看、分享自己擁有的POAP。",
  },
  // 首页收到礼物
  indexGiftShow: {
    text1: "收到來自的",
    text2: "好友的禮物",
    btn1: "關閉",
    btn2: "去查看",
  },
  //盲盒赠送页面
  giftBox: {
    text1: "贈送須知",
    text2: "請您務必審慎閱讀 充分理解以下內容",
    text3: "數字藏品/證書不具備交易價值，僅為確權工具，請勿炒作。",
    text4: "立足於通過數字證書進行商品防偽溯源，保護正版價值。",
    text5: "如需線下贈予好友食物藏品，請同時將匹配的數字證書贈送給獲贈人。",
    text6: "本數字藏品不得用於炒作、場外交易和任何商業用途。如發現存在炒作等異常行為、涉嫌違法違規或協議禁止的行為，我們有權採取必要的限制措施；包含但不限於凍結賬號等。",
    text7: "請遠離數字藏品非理性炒作，防範欺詐風險。",
    text8: "拒絕",
    text9: "同意",
    text10: "你還未設置密碼，請前往設置",
    text11: "前往設置",
  },
  actKeys: {
    ruleModel: {
      title: "活動規則",
      text1: "活動時間：2022-08-29至2022-09-30，活動時間內通過分享活動，邀請尚未參加本活動的用戶參加、註冊、認證、購買盲盒等獲得能量值（限量盲盒活動分享無效）。",
      text111: "本活動僅針對「精裝盲盒」，「限量盲盒」不參與該活動",
      text2: "能量值獎勵",
      text3: "1、分享專題活動，邀請1位用戶參與本次活動，即可獲得數字人人物周杰倫專屬動作“哥覺得可以”。",
      text4: "2、分享邀請好友註冊 +1能量/人",
      text5: "3、分享邀請好友完成實名認證，+2能量/人",
      text6: "4、分享邀請用戶購買精裝盲盒，+5能量/盲盒。",
      text7: "5、用戶自己購買精裝盲盒，+10能量/盲盒",
      text8: "6、邀請6位新用戶付費購買，可獲得一個精裝盲盒，無上限。盲盒數量不在30個限制內。",
      text9: "每日能量值單獨統計，能量值排名第一獎勵",
      text10: "1、獲得一把傳奇鑰匙。",
      text11: "2、獲得周杰倫簽名照一張。",
      text12: "3、獲得【最偉大的作品】精裝版實體專輯一張。",
      text13: "4、獲得限量海報一張。",
      text14: "以系統判定當日首先到達最高分為準。以上所得獎勵以官方發放安排為主。",
      text15: "本著公平公正的規則，維護正常參與用戶的權益，如在活動中發現有人通過違規的方式進行刷單、刷榜等行為，我們將會第一時間取消該用戶的活動參與資格。",
      text16: "4、邀請好友+好友認證每日上限800能量，如達到800能量後，再邀請好友完成註冊或認證不再額外獲得能量"
    },
    page: {
      createorName: "杰威爾音樂",
      actName: "周杰倫限定珍藏DEMO空間",
      goMscHome: "音樂空間",
      tickets: "開啟周杰倫音樂元宇宙門票的數字鑰匙",
      actTime: {
        title: "活動週期：",
        stime: "活動開始時間：8月29日",
        etime: "活動結束時間：9月30日",
      },
      rankInfo: {
        text1: "傳奇鑰匙33把、周杰倫簽名照33張",
        text2: "【最偉大的作品】精裝版實體專輯+限量海報33份",
      },
      btmShare: "邀請好友，獲得更多驚喜",
      news: {
        text1: "恭喜用戶",
        text2: "獲得",
        text3: "把",
      },
      moreAward: {
        text1: "購買盲盒即可獲得",
      },
      textInfo1: "“數字鑰匙”作為唯一進入『 周杰倫限定珍藏DEMO空間 』憑證，“數字鑰匙”分為經典、稀有、傳奇三種等級，本次發售盲盒分精裝盲盒、限量盲盒兩款。 『周杰倫限定珍藏DEMO空間』進入空間唯一憑證『可收藏數字鑰匙盲盒』8月29日正式開售。",
      navName1: "活動詳情",
      navName2: "排行榜",
      rankTabName1: "今日排名",
      rankTabName2: "今日能量值",
      rankTabName3: "累計能量值",
      rankTabName4: "邀請購買總人數",
      rankTableTh1: "排名",
      rankTableTh2: "用戶",
      rankTableTh3: "今日獲得能量值",
      actTitle1: "空間入場憑證",
      actTitle2: "盲盒活動",
      actTitle3: "排行榜",
      rewardInfoTitle1: "獎勵",
      rewardInfoTitle2: "活動條件",
      sTit1: "殿堂級的音樂藝術結合前端數字音樂視聽收藏技術開啟周氏元宇宙第一站 ",
      // sTit2: "殿堂級的音樂藝術結合前端數字音樂視聽收藏技術開啟周氏元宇宙第一站",
      storyText: "杰威爾音樂與薄盒Mints跨界強強聯手打造華語樂壇殿堂級音樂元宇宙『 周杰倫限定珍藏DEMO空間 』，音樂DEMO空間由5首精選DEMO組成，每首皆為周杰倫親自挑選，其中包含4首在華人世界具超高傳唱度且為經典代表的歌曲DEMO如《青花瓷》、《愛在西元前》、《晴天》、《擱淺》，<b>以及1首從未發表且完成度極高如新歌的隱藏DEMO曲目《紐約地鐵》</b>。 『 周杰倫限定珍藏DEMO空間 』除了是華語樂壇數字音樂收藏的極致視聽盛宴，雙方更致力於結合元宇宙視覺影像的前衛風格與設計概念，融合初始音樂DEMO與區塊鏈技術拓展未來數字音樂收藏世界的新思路，創造出兼具未來科技感的Jay式音樂元宇宙。總是喜歡挑戰與嘗試新事物的周杰倫，如今將帶著他滿載且前所未見的音樂能量在薄盒首次啟動專屬的元宇宙，將屬於周杰倫音樂創作的每一個音符、旋律、編曲、BEAT、歌詞、畫面，在區塊鏈上進階成為永不消逝的經典收藏。",
      btn1: "￥20",
      btn2: "￥499",
      btn11: "精裝盲盒",
      btn22: "限量盲盒",
      ruleName: "活動規則",
      noTableData: "暫無數據",

      redT: {
        title: "JAY紅色帽衫",
        info1: "購買精裝盲盒或限量盲盒，可自動獲得一套紅色帽衫3D服裝（可穿戴數字藏品），每人上限1套。",
        info2: "限時不限量，只可在活動期間內獲得。",
      },
      mns: {
        title: "MNS",
        info1: "元宇宙數字身份，購買精裝盲盒或限量盲盒，可獲得一個MNS名稱0元名額，有效期截止活動結束。",
        info2: "",
      },
      poap: {
        title: "POAP",
        info1: "獲得任意鑰匙後，在充分探索周杰倫音樂Demo空間時，且當你到達空間中的某個位置，即可獲得一枚POAP徽章。",
        info2: "總徽章上線10萬個，贈完為止。",
      },
    },
    rankPage: {
      index: "序號",
      user: "用戶",
      operation: "用戶操作",
      value: "能量值",
      dayValue: "今日能量值",
      countValue: "累計能量值",
      time: "下單時間",
      boxReward: "盲盒獎勵",
      buyCount: "邀請購買總數人",
    }
  },
}



// WEBPACK FOOTER //
// ./src/i18n/config/zh-tw.js